// =============================
// Imports
// =============================

import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Flex } from '@mewo/components';
import Link from '../../other/link';

import { PgnButton, StyledArrowSingle, StyledArrowDouble } from './styles';

// =============================
// Component
// =============================

class Pagination extends PureComponent {
  static propTypes = {
    /** Props used by styled component to override styles. */
    className: PropTypes.string,
    /** Current page */
    currentPage: PropTypes.number.isRequired,
    /** Total number of pages */
    pageCount: PropTypes.number.isRequired,
    /** Function to build page links */
    buildSearchLink: PropTypes.func.isRequired,
    /** Disable paginating */
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    disabled: false,
  };

  getDisplayPageNumber = pageNb => pageNb + 1;

  render() {
    const { className, currentPage, buildSearchLink, pageCount, disabled } = this.props;

    // If pageCount is 1, do not render anything
    if (pageCount <= 1) return null;

    const nbPageShowed = 2; // Number of page showed before & after currentage

    // Check if the page is far from beggining & end
    const farFromBeginning = currentPage - nbPageShowed >= 1;
    const farFromEnd = pageCount - 1 - nbPageShowed > currentPage;

    // Render Previous page from current one
    const prevPages = [];
    for (let i = 1; i <= nbPageShowed; i += 1) {
      if (currentPage - i >= 0) {
        prevPages.unshift(
          <Link
            route={buildSearchLink(currentPage - i)}
            key={currentPage - i}
          >
            <PgnButton isAccessible={!disabled}>
              {this.getDisplayPageNumber(currentPage - i)}
            </PgnButton>
          </Link>,
        );
      }
    }

    // Render Next page from current one
    const nextPages = [];
    for (let i = 1; i <= nbPageShowed; i += 1) {
      if (currentPage + i <= pageCount - 1) {
        nextPages.push(
          <Link
            key={currentPage + i}
            route={buildSearchLink(currentPage + i)}
          >
            <PgnButton isAccessible={!disabled}>
              {this.getDisplayPageNumber(currentPage + i)}
            </PgnButton>
          </Link>,
        );
      }
    }

    return (
      <Flex className={className} justify="center" align="center">
        <Link route={buildSearchLink(0)}>
          <PgnButton isAccessible={currentPage > 0 && !disabled}>
            <StyledArrowDouble dir="west" />
          </PgnButton>
        </Link>
        <Link route={buildSearchLink(currentPage - 1)}>
          <PgnButton isAccessible={currentPage > 0 && !disabled}>
            <StyledArrowSingle dir="west" />
          </PgnButton>
        </Link>
        {farFromBeginning && (
          <Flex>
            {currentPage - nbPageShowed > 1 && <PgnButton isAccessible={false}>...</PgnButton>}
          </Flex>
        )}

        {prevPages}
        <PgnButton active isAccessible={!disabled}>
          {this.getDisplayPageNumber(currentPage)}
        </PgnButton>
        {nextPages}

        {farFromEnd && (
          <Flex>
            {pageCount - 1 - (nbPageShowed + 1) !== currentPage && (
              <PgnButton isAccessible={false}>...</PgnButton>
            )}
          </Flex>
        )}
        <Link route={buildSearchLink(currentPage + 1)}>
          <PgnButton isAccessible={currentPage < pageCount - 1 && !disabled}>
            <StyledArrowSingle dir="east" />
          </PgnButton>
        </Link>
        <Link route={buildSearchLink(pageCount - 1)}>
          <PgnButton isAccessible={currentPage < pageCount - 1 && !disabled}>
            <StyledArrowDouble dir="east" />
          </PgnButton>
        </Link>
      </Flex>
    );
  }
}

export default Pagination;
